export const profileAction = profile => ({
  type: 'PROFILE',
  profile,
})
